import { Box } from '@mui/material';
import MoneyRendererV3 from '../../../../../components/Money/MoneyRendererV3/MoneyRendererV3';
import Typography from '../../../../../components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import MarkupChip from '../../../MarkupChip';
import { RetailPriceSectionMobileProps } from '../interfaces/retailPriceSection.interfaces';

const RetailPriceSectionMobile = ({
  markup,
  showMarkup,
  retailPriceRange,
  hasRetailPriceVariation,
}: RetailPriceSectionMobileProps) => {
  const { translate } = useTranslation();

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        gap: theme.spacing(1 / 2),
      })}
    >
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'flex-end',
          gap: theme.spacing(1 / 2),
        })}
      >
        {hasRetailPriceVariation && (
          <>
            <MoneyRendererV3 value={retailPriceRange.min} color="textSecondary" />
            <Typography variant="body1">-</Typography>
          </>
        )}
        <MoneyRendererV3 value={retailPriceRange.max} color="textSecondary" />
        <Typography variant="body2" color="text.secondary">
          {translate(LangEnum.GLOBAL_SUGGESTED_SINGULAR)}
        </Typography>
      </Box>
      {showMarkup && markup && <MarkupChip markupValue={markup} markupTextInLabel />}
    </Box>
  );
};

export default RetailPriceSectionMobile;
